import type { Action } from 'redux';
import NotificationActions from '../../../../main/actions/NotificationActions';
import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type { UserBranchAccountProps } from '../BranchAccount.types';

export const GetUserBranchAccount = new ReduxAsyncAction<'GET_USER_BRANCH_ACCOUNT', void, UserBranchAccountProps>(
  'GET_USER_BRANCH_ACCOUNT'
);

export const GET_USER_BRANCH_ACCOUNT_ACTION_CONSTANTS = GetUserBranchAccount.actionNamespaceConstants;

GetUserBranchAccount.registerRequest(async () => {
  try {
    const { data } = await dash_api.get<UserBranchAccountProps>(`/v1/dashboard-user/user-branch-account`);
    return data;
  } catch (error) {
    NotificationActions.showNotification('Failed to fetch user Branch Account information.', 'error');

    throw error;
  }
});

export const getUserBranchAccount = GetUserBranchAccount.request;

export type GetUserBranchAccountResponseAction = Action<typeof GET_USER_BRANCH_ACCOUNT_ACTION_CONSTANTS.response> & {
  data: UserBranchAccountProps;
};
